import { Modal } from 'antd';

import ModalFooter from '@/UI/ModalFooter';

import type { ReactNode } from 'react';

type DestructiveConfirmModalProps = {
  open: boolean;
  title: ReactNode;
  okText: ReactNode;
  cancelText: ReactNode;
  onOk: () => void;
  onCancel: () => void;
  children: ReactNode;
  closable?: boolean;
};

export function DestructiveConfirmModal({
  open,
  title,
  okText,
  cancelText,
  onOk,
  onCancel,
  children,
  closable = false,
}: DestructiveConfirmModalProps) {
  return (
    <Modal
      closable={closable}
      open={open}
      title={title}
      okText={okText}
      cancelText={cancelText}
      okButtonProps={{ danger: true }}
      onOk={onOk}
      onCancel={onCancel}
      footer={(_originNode, { OkBtn, CancelBtn }) => (
        <ModalFooter
          actions={
            <>
              <CancelBtn />
              <OkBtn />
            </>
          }
        />
      )}
    >
      {children}
    </Modal>
  );
}
